import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

/** Props Interface */
interface UseProjectProps {
	projectId: Nullable<string>;
}

export function useProject({ projectId }: UseProjectProps) {
	/** Query */
	const query = useQuery({
		queryKey: ["projects", guardString(projectId)],
		queryFn: async () => {
			if (!projectId) throw new Error("Project Id needed");
			const response = await client.projects[":projectId"].$get({
				param: { projectId },
			});

			// No toast: this hook is what the capability checks on a project's surfaces bind their
			// rules to, so it runs wherever one of them is rendered — a row menu, a card, a form.
			// A caller whose reach does not cover the site is refused here on every one of them,
			// and the surfaces say so themselves: the page with a no-access state, a menu by not
			// offering the entry.
			const data = await responseHandler(response, false);
			return data.project;
		},
		enabled: !!projectId,
	});

	return { project: query.data, ...query };
}
